<template>
  <div>
    <wc-data-box
      :title='headerData.title'
      :titleIcon='headerData.icon'
      :titleIconColor='headerData.color'
      :loading='loading'
      showAdd
      showSearch
      v-model='search'
      @add='openAdd'
    >
      <v-data-table
        dense
        :items='categories'
        :headers='headers'
        :search='search'
        :items-per-page='4'
        :footer-props='{ "items-per-page-options": [4,10,-1] }'
        @click:row='openEdit'
        sort-by='description'
      >
        <template v-slot:item.category_type='{ item }'>
          <v-chip label xSmall v-if='item.has_gst' color='error' class='mr-1'>GST</v-chip>
          <v-chip label xSmall v-if='!item.has_gst && item.is_main_category' outlined color='error' class='mr-1'>No GST</v-chip>
          <v-chip label xSmall :color='getTypeData(item.category_type).color'>{{ getTypeData(item.category_type).text }}</v-chip>
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='dialogTitle'
      :icon='headerData.icon'
      width='400'
      @save='save'
      @cancel='showDialog = false'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <v-text-field
              v-model='categoryCopy.description'
              label='Category name'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='6'>
            <v-radio-group v-model='categoryType'>
              <v-radio value='m'>
                <template v-slot:label>
                  <div>Main category</div>
                </template>
              </v-radio>
              <v-radio value='s'>
                <template v-slot:label>
                  <div>Sub category</div>
                </template>
              </v-radio>
              <v-radio value='ss'>
                <template v-slot:label>
                  <div>Sub SUB category</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols='6'>
            <v-checkbox
              :disabled='!categoryCopy.is_main_category'
              v-model='categoryCopy.has_gst'
              label='GST included?'
              dense
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import _ from 'lodash'

export default {
  name: 'budgets',
  mixins: [formRules],
  props: {
    categories: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showDialog: false,
    isFormValid: false,
    dialogTitle: 'Add Category',
    search: '',
    categoryType: 'm', // m = main, s = sub, ss = sub SUB
    categoryCopy: {
      description: '',
      is_main_category: true,
      is_sub_category: false,
      is_sub_sub_category: false,
      has_gst: false
    },
    headers: [
      { text: 'Description', value: 'description' },
      { text: 'Type', value: 'category_type', align: 'right' }
    ]
  }),
  watch: {
    categoryType () {
      switch (this.categoryType) {
        case 'm':
          this.categoryCopy.is_main_category = true
          this.categoryCopy.is_sub_category = false
          this.categoryCopy.is_sub_sub_category = false
          break
        case 's':
          this.categoryCopy.is_main_category = false
          this.categoryCopy.is_sub_category = true
          this.categoryCopy.is_sub_sub_category = false
          this.categoryCopy.has_gst = false
          break
        case 'ss':
          this.categoryCopy.is_main_category = false
          this.categoryCopy.is_sub_category = false
          this.categoryCopy.is_sub_sub_category = true
          this.categoryCopy.has_gst = false
          break
      }
    }
  },
  computed: {
    headerData () {
      return this.$store.state.icons.modules.budgetCategories
    }
  },
  methods: {
    resetCopy () {
      this.categoryCopy.description = ''
      this.categoryCopy.is_main_category = true
      this.categoryCopy.is_sub_category = false
      this.categoryCopy.is_sub_sub_category = false
      this.categoryCopy.has_gst = false
      this.setCategoryType()
    },
    setCategoryType () {
      if (this.categoryCopy.is_main_category) {
        this.categoryType = 'm'
      } else if (this.categoryCopy.is_sub_category) {
        this.categoryType = 's'
      } else if (this.categoryCopy.is_sub_sub_category) {
        this.categoryType = 'ss'
      }
    },
    openAdd () {
      this.resetCopy()
      this.showDialog = true
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    openEdit (item) {
      this.categoryCopy = _.cloneDeep(item)
      this.setCategoryType()
      this.showDialog = true
    },
    save () {
      this.$emit('saveCategory', this.categoryCopy)
      this.showDialog = false
    },
    getTypeData (cat) {
      let data = {
        text: '',
        color: ''
      }
      switch(cat) {
        case 'main':
          data.text = 'Main'
          data.color = 'primary'
          break
        case 'sub':
          data.text = 'Sub'
          data.color = 'primary lighten-2'
          break
        case 'sub_sub':
          data.text = 'Sub SUB'
          data.color = 'primary lighten-4'
          break
      }
      return data
    }
  }
}
</script>
